import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Redirect } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import { Grid, Col, Row, Button } from 'react-bootstrap';


import {
    loseAuth as loseAuthAction,
    auth as authAction
} from '../actions/auth';


import * as fetchingStates from '../constants/fetchingState';
import * as errorCode from '../constants/errorCode';

const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
    <div className='form-group'>
        <label className='control-label col-sm-2'>{label}</label>
        <div className='controls col-sm-2'>
            <input {...input} placeholder={label} type={type} />
            {touched && ((error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>) || (warning &&
                <span>{warning}</span>))}
        </div>
    </div>
);

const errMap = {
    [errorCode.NOT_FOUND]: 'Неправильный логин или пароль',
    [errorCode.DELETED]: 'Пользователь заблокирован',
    [errorCode.INTERNAL_ERROR]: 'Внутренняя ошибка',
};

let Auth = class extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            redirectToReferrer: false
        };

        this._onSubmit = this._onSubmit.bind(this);
    }

    componentWillMount() {
        if (this.props.user && !sessionStorage.getItem('adm-token')) {
            this.props.loseAuthAction();
        } else if (this.props.user && sessionStorage.getItem('adm-token')) {
            const { from } = this.props.location.state || { from: { pathname: '/' } };
            this.props.push(from);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.user && nextProps.user) {
            this.setState({ redirectToReferrer: true });
        }
    }

    _onSubmit(values) {
        this.props.authAction(values);
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: '/' } };
        const { authError, fetching } = this.props;
        const { handleSubmit, pristine, submitting } = this.props;
        const { redirectToReferrer } = this.state;

        if (redirectToReferrer) {
            return (<Redirect to={from} />);
        }

        const errStr = errMap[authError];

        return (
            <Grid fluid style={{ marginTop: '30px' }}>
                <Row>
                    <Col lg={3} lgPush={5}>
                        <form className='form-horizontal' onSubmit={handleSubmit(this._onSubmit)}>
                            <Field name="Login" type="text" placeholder="Логин" component={renderField}
                                label="Логин" />

                            <Field name="Password" type="password" placeholder="Пароль" component={renderField}
                                label="Пароль" />
                            <Button bsStyle="success"
                                type="submit"
                                disabled={pristine || submitting || fetching === fetchingStates.FETCHING}
                                onClick={handleSubmit(this._onSubmit)}>
                                Войти
                            </Button>
                        </form>
                    </Col>
                </Row>
                {fetching === fetchingStates.FETCHED &&
                    <Row style={{ marginBottom: "10px" }}>
                        <Col lg={3} lgPush={5}>
                            <span style={{ color: "red", marginLeft: "5px", fontSize: '20px' }}>
                                {errStr}
                            </span>
                        </Col>
                    </Row>}
                {fetching === fetchingStates.FAILED &&
                    <Row style={{ marginBottom: "10px" }}>
                        <Col lg={3} lgPush={5}>
                            <span style={{ color: "red", marginLeft: "5px", fontSize: '20px' }}>
                                {errMap[errorCode.INTERNAL_ERROR]}
                            </span>
                        </Col>
                    </Row>}
            </Grid>
        );
    }
}

Auth = reduxForm({
    form: 'auth'
})(Auth);

Auth = connect(state => ({
    user: state.application.get('auth').get('user'),
    authError: state.application.get('auth').get('error'),
    fetching: state.application.get('auth').get('fetching')
}), { push, loseAuthAction, authAction })(Auth);

export default Auth;


// WEBPACK FOOTER //
// ./src/components/Auth.jsx